import { render, staticRenderFns } from "./HomepagePopup.vue?vue&type=template&id=4039a774&scoped=true&"
import script from "./HomepagePopup.vue?vue&type=script&lang=js&"
export * from "./HomepagePopup.vue?vue&type=script&lang=js&"
import style0 from "./HomepagePopup.vue?vue&type=style&index=0&id=4039a774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4039a774",
  null
  
)

export default component.exports